import React, {Component} from 'react';
import CardWidget from "../card-widget/CardWidget";
import {RouteConstants} from "../route/services/RouteConstants";
import CardWidgetContent from "../card-widget/CardWidgetContent";
import ExternalLink from "../link/ExternalLink";
import HrbTranslate from "../language/HrbTranslate";
import "./ForgotPasswordSentConfirmation.scss"

class ForgotPasswordSentConfirmation extends Component {

  goNext = () => {
    this.props.history.push(RouteConstants.LOGIN);
  };

  getForgotPasswordSentContent = () => {
    return (
        <div>
          <CardWidgetContent contentText="forgotpassword.sent_confirmation"/>
          <div>
              <HrbTranslate text="forgotpassword.help_link_text_prefix"/>
              <span className="hrb-forgot-password-help-link">
                  <ExternalLink textKey="forgotpassword.help_link" linkKey="links.forgotpassword_sent_confirmation_help" isNewWindow={true}/>
              </span>
          </div>
        </div>
    )
  };

  render() {
    return (
        <CardWidget getCardContent={this.getForgotPasswordSentContent}
                    submitButtonAction={() => this.goNext()}
                    submitButtonText="forgotpassword.ok"/>
    )
  };
}

export default ForgotPasswordSentConfirmation;